import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VonRestService } from '@von-development-studio/angular-rest-service';

@Injectable({
  providedIn: 'root',
})
export class RestService extends VonRestService {
  constructor(override http: HttpClient, override sanitizer: DomSanitizer) {
    super(http, sanitizer);
  }

  mapResponseAsPdf = (res: any) => {
    const fileBlob = new Blob([res], { type: 'application/pdf' });
    const objUrl = URL.createObjectURL(fileBlob);
    const sanitized = this.sanitizer.bypassSecurityTrustResourceUrl(objUrl);
    return sanitized;
  };
}
